import React, { useState, useContext } from "react";
import { Typography } from "@mui/material";
import moment from "moment";

import { DataContext } from "../../../../context/DataContext";
import { getToken } from "../../../../api/Account";
import { updateFechaPagoAsync } from "../../../../api/Credits";
import { useAviso } from "../../../../components/base";
import { formatearFecha } from "../../../../helpers/formato";
import { CampoFecha, DialogoFormulario, useEnvio } from "../../../rrhh/employees/comunes";
import { mensajeFechaGuardada, textoRango, validarFechaCuota, vecinas } from "./fechaCuota";

/**
 * Cambia la fecha de pago de una cuota. No puede quedar antes de la cuota anterior ni después de
 * la siguiente; si cae en un día no hábil, el servidor la pasa al siguiente día hábil.
 */
const UpdateFechaPago = ({ cuota, plan, onCerrar, onGuardado }) => {
  const token = getToken();
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  const aviso = useAviso();
  const { guardando, enviar } = useEnvio();

  const [fecha, setFecha] = useState(moment(cuota.fechaPago).toDate());
  const [intentado, setIntentado] = useState(false);

  const rango = vecinas(cuota, plan);
  const error = intentado ? validarFechaCuota(fecha, rango) : "";
  const ayuda = [textoRango(rango), "Si no es día hábil, pasa al siguiente."].filter(Boolean).join(". ");

  const guardar = () =>
    enviar(async () => {
      setIntentado(true);
      if (validarFechaCuota(fecha, rango)) return;
      setIsLoading(true);
      try {
        const result = await updateFechaPagoAsync(token, {
          id: cuota.id,
          newfechaPago: moment(fecha).format("YYYY-MM-DD"),
        });
        setIsLoading(false);
        if (!result.statusResponse) {
          if (result.error === "Unauthorized") {
            setIsUnautorized(true);
            return;
          }
          aviso.error(result.error || "No se pudo cambiar la fecha de la cuota");
          return;
        }
        const guardada = result.data?.result?.fechaPago || fecha;
        onGuardado(mensajeFechaGuardada(cuota.numeroCuota, fecha, guardada));
      } catch (e) {
        setIsLoading(false);
        aviso.error("No se pudo conectar con el servidor. Inténtalo de nuevo.");
      }
    });

  return (
    <DialogoFormulario
      titulo={`Cambiar la fecha de la cuota ${cuota.numeroCuota}`}
      onCerrar={onCerrar}
      hayCambios={!moment(fecha).isSame(moment(cuota.fechaPago), "day")}
      guardando={guardando}
      onEnviar={guardar}
      textoEnviar="Cambiar fecha"
    >
      <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
        {`Fecha actual: ${formatearFecha(cuota.fechaPago)}. Solo cambia esta cuota; los días de las cuotas vecinas se recalculan.`}
      </Typography>
      <CampoFecha
        label="Nueva fecha de pago"
        value={fecha}
        onChange={(nueva) => setFecha(nueva)}
        error={error}
        ayuda={ayuda}
        disabled={guardando}
        required
      />
    </DialogoFormulario>
  );
};

export default UpdateFechaPago;
